module.exports = __webpack_public_path__ + "img/zhgd_image.23a4ed08.png";